import { Skeleton } from '@mui/material';
import { IconSailboat } from '@tabler/icons-react';

const BoatFeatureSkeleton = () => {
  return (
    <div className="mt-2 flex flex-col items-start gap-6 self-stretch">
      {/* Header */}
      <div className="flex gap-2 items-center">
        <IconSailboat size={24} />
        <Skeleton variant="text" width={150} height={32} />
      </div>

      {/* Mobile Version Facilities Skeleton */}
      <div className="flex flex-col items-start gap-4 flex-1 text-neutral-500 md:hidden">
        {[1, 2, 3, 4, 5].map(item => (
          <div key={item} className="flex items-center gap-2">
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="text" width={200} height={24} />
          </div>
        ))}
      </div>

      {/* Desktop Version Facilities Skeleton */}
      <div className="hidden grid-cols-2 items-start gap-4 flex-1 text-neutral-500 max-w-[40.3125rem] w-full md:grid">
        {[...Array(10)].map((_, index) => (
          <div key={index} className="flex items-center gap-2">
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="text" width={200} height={24} />
          </div>
        ))}
      </div>

      {/* Buttons */}
      <div>
        <button
          className="flex px-6 py-3 justify-center items-center gap-2 rounded-lg border border-neutral-800 md:hidden"
          disabled
        >
          <Skeleton variant="text" width={150} height={24} />
        </button>
        <button
          className="hidden md:flex px-6 py-3 justify-center items-center gap-2 rounded-lg border border-neutral-800"
          disabled
        >
          <Skeleton variant="text" width={200} height={24} />
        </button>
      </div>
    </div>
  );
};

export default BoatFeatureSkeleton;
